import React from "react";
import Stock from "components/Tvendo/Article/DataMaster/Stock/List";

export default function () {
  return <Stock />;
}
